import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../services/adminApi';
import './Admin.css';

function AdminLogin() {
    const navigate = useNavigate();
    const [form, setForm] = useState({ username: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm((previous) => ({ ...previous, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');

        try {
            await adminLogin(form.username.trim(), form.password);
            navigate('/admin', { replace: true });
        } catch (submitError) {
            setError(submitError.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-auth-page">
            <div
                className="admin-auth-hero"
                style={{
                    backgroundImage: `linear-gradient(135deg, rgba(17, 61, 72, 0.85) 0%, rgba(28, 168, 203, 0.75) 100%), url(${process.env.PUBLIC_URL}/assets/img/hero/hero-1-1.jpg)`
                }}
            >
                <div className="admin-auth-hero-brand">
                    <img
                        src={`${process.env.PUBLIC_URL}/assets/img/logo-white.png`}
                        alt="Himolan Peak Adventures"
                    />
                </div>

                <div className="admin-auth-hero-content">
                    <h2>Manage your adventures from one beautiful dashboard.</h2>
                    <p>
                        Publish tours, packages, blogs and destinations. Upload images,
                        write rich content, and see a live preview before going public.
                    </p>

                    <div className="admin-auth-hero-features">
                        <div><i className="fas fa-check"></i> Live side-by-side preview while you type</div>
                        <div><i className="fas fa-check"></i> Image uploads with secure storage</div>
                        <div><i className="fas fa-check"></i> Module-specific rich content fields</div>
                        <div><i className="fas fa-check"></i> Fully responsive — works on every device</div>
                    </div>
                </div>

                <div style={{ position: 'relative', zIndex: 1, color: 'rgba(255,255,255,0.55)', fontSize: 12 }}>
                    &copy; Himolan Peak Adventures · Admin Panel
                </div>
            </div>

            <div className="admin-auth-form-wrap">
                <div className="admin-auth-card">
                    <h1 className="admin-auth-title">Welcome back</h1>
                    <p className="admin-auth-subtitle">Sign in to manage your website content</p>

                    <form onSubmit={handleSubmit} className="admin-auth-form">
                        <div>
                            <label htmlFor="username">Username</label>
                            <div className="admin-input-icon">
                                <i className="fas fa-user"></i>
                                <input
                                    id="username"
                                    name="username"
                                    type="text"
                                    placeholder="Enter your username"
                                    value={form.username}
                                    onChange={handleChange}
                                    required
                                    autoFocus
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="password">Password</label>
                            <div className="admin-input-icon">
                                <i className="fas fa-lock"></i>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    placeholder="Enter your password"
                                    value={form.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        {error && (
                            <div className="admin-toast error">
                                <i className="fas fa-circle-exclamation"></i>
                                {error}
                            </div>
                        )}

                        <button type="submit" className="admin-btn full" disabled={loading}>
                            {loading ? (
                                <>
                                    <i className="fas fa-spinner fa-spin"></i>
                                    Signing in...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-arrow-right-to-bracket"></i>
                                    Sign In
                                </>
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;
